goog.provide('el8.print.idpConsent');

goog.require('el8.data.init');
goog.require('el8.data.physicians');
goog.require('el8.data.practices');
goog.require('el8.template.print.idpConsent');
goog.require('el8.util.print');

el8.print.idpConsent.init = function(spec) {

    var physician = spec.physician ? el8.data.physicians.create(spec.physician): null;

    $('.print-content').replaceWith(
        el8.template.print.idpConsent.content({
            physician: physician ? physician.asSoyMap() : null,
            now: el8.service.tz.soyStr(el8.service.tz.now())
        })
    );

    el8.util.print.pageSetup();
};

